<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" sm="12" xs="12" class="d-flex justify-content-between align-items-center">
        <button v-if="
          verificBead == false &&
          this.box &&
          ($store.getters.get_rol.id == 2 ||$store.getters.get_rol.id == 1 )
        " @click="mtdOpenModalOpenBead" type="button" class="btn btn-sm text-white" style="background: #136949">
          <i class="fas fa-cash-register"></i> Abrir Caja
        </button>
        <!-- Botón para cerrar caja -->
        <button v-if="
          verificBead == true &&
          this.box &&
          ($store.getters.get_rol.id == 2 || $store.getters.get_rol.id == 1)
        " @click="mtdCloseBead" type="button" class="btn btn-sm text-white" style="background: #136949">
          <i class="fas fa-cash-register"></i> Cerrar Caja
        </button>
        
        <!-- Total vendido del día -->
        <div class="text-center">
          <h5 class="mb-0">
            <span class="text-muted">Total Vendido Hoy:</span>
            <span class="font-weight-bold text-success ml-2">S/. {{ totalVendidoHoy }}</span>
          </h5>
        </div>
        
        <button @click="mtdBackRol" type="button" class="btn btn-sm text-white" style="background: #e46666">
          <i class="fas fa-hand-point-left"></i> Cambiar de rol
        </button>
      </CCol>
    </CRow>
    <CCardBody>
      <CRow class="mt-2" v-if="mostrarWidget">
        <CCol sm="6" lg="4">
          <CWidgetIcon :header="'S/. ' + totalApertura" text="Apertura de Caja" color="gradient-info">
            <i class="fas fa-solid fa-sack-dollar fa-2x"></i>
          </CWidgetIcon>
        </CCol>
        <CCol sm="6" lg="4">
          <CWidgetIcon :header="'S/. ' + totalIngresos" text="Total de Ingresos" color="gradient-warning">
            <i class="fas fa-solid fa-coins fa-2x"></i>
          </CWidgetIcon>
        </CCol>
        <CCol sm="6" lg="4">
          <CWidgetIcon :header="'S/. ' + totalCaja" text="Monto Total en Caja" color="gradient-success">
            <i class="fas fa-solid fa-cash-register fa-2x"></i>
          </CWidgetIcon>
        </CCol>
        <!-- <CCol sm="6" lg="3">
            <CWidgetIcon :header="String(totalCitas)" text="Total de Citas" color="gradient-primary">
              <i class="fas fa-solid fa-user-clock fa-2x"></i>
            </CWidgetIcon>
          </CCol> -->
      </CRow>
      <CRow>
        <CCol md="6">
          <CCard>
            <CCardHeader class="text-center text-uppercase font-weight-bold">
              Ingresos del Día
            </CCardHeader>
            <CCardBody>
              <ChartDaycharge @dailyTotal="totalVentaDia = $event" @dailyPending="totalPendienteDia = $event" @dailyTotalSold="totalVendidoHoy = $event" />
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md="6">
          <CCard>
            <CCardHeader class="text-center text-uppercase font-weight-bold">
              Ingresos del Mes
            </CCardHeader>
            <CCardBody>
              <ChartMonthcharge />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" md="12">
          <transition name="fade">
            <CCard v-if="show">
              <CCardHeader class=" text-center text-uppercase font-weight-bold">
                Ingresos Anuales
                <div class="card-header-actions">
                  <CLink class="card-header-action btn-minimize" @click="isCollapsed = !isCollapsed">
                    <CIcon :name="`cil-chevron-${isCollapsed ? 'bottom' : 'top'}`" />
                  </CLink>
                </div>
              </CCardHeader>
              <CCollapse :show="isCollapsed" :duration="400">
                <CCardBody>
                  <ChatAnnualCharge :key="isCollapsed ? 1 : 0" />
                </CCardBody>
              </CCollapse>
            </CCard>
          </transition>
        </CCol>
      </CRow>

    </CCardBody>
    <cModalOpenBead :title="modalOpenBead.title" :boo_modal="modalOpenBead.modal_form"
      @closeModalOpenBead="closeModalOpenBead" @save="handleSave">
    </cModalOpenBead>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
import cModalOpenBead from "../../caja/demo/modals/cModalOpenBead.vue";
import ChartDaycharge from "./Components/ChartDayCharge.vue";
import ChartMonthcharge from "./Components/ChartMontCharge.vue";
import ChatAnnualCharge from "./Components/ChatAnnualCharge.vue";


export default {
  name: "home-adminCompany",
  components: {
    cModalOpenBead,
    ChartDaycharge,
    ChartMonthcharge,
    ChatAnnualCharge,
  },
  data() {
    return {
      prefix: "beads",
      box: false,
      verificBead: false,
      modalOpenBead: {
        title: "Registrar monto de inicio",
        modal_form: false,
      },
      company: {
        logo: "",
      },
      totalApertura: "",
      totalIngresos: "",
      totalCaja: "",
      totalCitas: "",
      totalVentaDia: 0,
      totalPendienteDia: 0,
      totalVendidoHoy: 0,
      filter: {
        init: null,
        end: null,
      },
      //Collapse
      show: true,
      isCollapsed: true,
      chartIcome: {
        data: [],
        methodsPayment: [],
      },
    };
  },
  computed: {
    mostrarWidget() {
      return this.$store.getters.get_rol.id === 7;
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.showBead();
    this.showCompany();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBackRol: function () {
      this.$store.commit("mt_set_rol", null);
    },
    mtdCloseBead: function () {
      this.$parent.setView("close_bead");
    },
    mtdOpenModalOpenBead() {
      this.modalOpenBead = {
        title: "Aperturar Caja",
        modal_form: true,
      };
    },
    closeModalOpenBead() {
      this.modalOpenBead = {
        modal_form: false,
      };
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.verificBead = response.data ? true : false;
            this.bead = this.verificBead == true ? response.data : {};
            this.totalApertura = response.data ? response.data.initial : '';
            this.totalIngresos = response.data ? response.data.income : '';
            this.totalCaja = response.data ? response.data.final : '';
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    showCompany() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showCompany/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.box = response.data.box;
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    handleSave() {
      this.showBead();
      this.modalOpenBead = {
        modal_form: false,
      };
    },
    /** graficos1 */
    dataCamalDisp() {
      const hasCamalDispatchData =
        this.camalDisp.quantity_kg > 0 || this.camalDisp.peso_neto > 0;
      return [
        {
          label: "CANTIDAD KG",
          backgroundColor: hasCamalDispatchData ? "#96afe9" : "#CCCCCC",
          data: hasCamalDispatchData ? [this.camalDisp.quantity_kg] : [1],
        },
        {
          label: "PESO NETO",
          backgroundColor: hasCamalDispatchData ? "#d096e9" : "#CCCCCC",
          data: hasCamalDispatchData ? [this.camalDisp.peso_neto] : [1],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>